import styled from 'styled-components'

export const Container = styled.main`
    min-height: calc(
        100vh - ${(props) => {return props.theme.headerHeight}}px
            - ${(props) => {return props.theme.footerHeight}}px
    );
    color: ${(props) => {return props.theme.colorPrimary}};
    display: flex;
    flex-direction: column;

    .hidden {
        display: none;
    }

    .spinner-box {
        display: flex;
        justify-content: end;
        align-items: center;
        flex-direction: column;
        height: 150px;

        .sk-spinner {
            transform: scale(2);
        }

        span {
            margin-top: 40px;
            font-size: 1.3rem;
        }
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px 20px 0;
    height: 1fr;
    width: 1100px;
    max-width: 100%;
    margin: 0 auto;

    .search {
        max-width: 700px;
    }

    .mais {
        display: flex;
        justify-content: center;
        padding: 20px 0;

        div {
            background-color: rgba(228,228,228,.22);
            padding: 3px 25px;
            border-radius: 4px;
            cursor: pointer;
            border: 1px solid #1A354940;
            font-size: .8rem;

            &:hover {
                border: 1px solid;
            }
        }
    }
`

export const Filters = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-right: 10px;

    > div {
        margin: 0 10px 10px 0;
    }

    .clear-filters {
        background-color: #fafafa;
        padding: 8px 10px;
        border-radius: 6px;
        font-size: .9rem;
        cursor: pointer;

        &:hover {
            background-color: #f3f3f3;
        }
    }

`
